import { DefaultComponents } from "@aws-amplify/ui-react/dist/types/components/Authenticator/hooks/useCustomComponents/defaultComponents";
import { LoginGlobalHeader } from "./loginGlobalHeader";
import { SignupHeader } from "./signupHeader";
import { AH4 } from "./text";


export const loginComponents : DefaultComponents = {
    Header() {
      return <LoginGlobalHeader />
    },
    SignIn: {
      Header() {
        return null;
      },
    },
    SignUp: {
      Header() {
        return <SignupHeader />
      }
    }
  }